/* eslint-disable jsx-a11y/label-has-associated-control */
/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatCurrencyWithoutCurrency, keyEmptyCheck } from 'aurora-utils/utils';
import { Box, withStyles } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import isEmpty from 'lodash/isEmpty';
import Container from '@material-ui/core/Container';
import { CancelApplicationModal, ADGMBreadcrumbs, ADGMImage } from 'aurora-components';

import { useDispatch, useSelector } from 'react-redux';
import { fetchWallet } from 'aurora-composition/modules/wallet/actions';

import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import classNames from 'classnames';
import styles from '../styles';
function Payment(props) {
  const {
    classes,
    children,
    breadCrumbs,
    balance,
    breakdown,
    paymentHanlder,
    showCancelApplication,
    submitCancelApplication,
  } = props;

  const dispatch = useDispatch();
  const { walletError } = useSelector(state => state.walletReducer);

  const [lowBalance, setLowBalance] = useState(false);
  const [walletActive, setWalletActive] = useState(false);
  const [cardActive, setCardActive] = useState(true);
  const [isModalOpenApplicationReject, setModalOpenApplicationReject] = useState(false);

  useEffect(() => {
    if (breakdown) {
      const islowBalance = balance < breakdown?.totalAmount;
      setLowBalance(islowBalance);
      // setWalletActive(!islowBalance);
      // setCardActive(islowBalance);
    }
  }, [breakdown, balance]);

  const payNowHanlder = () => {
    if (walletActive) {
      paymentHanlder('WALLET');
    } else {
      paymentHanlder('CARD');
    }
  };

  const creditCardHandler = () => {
    setCardActive(true);
    setWalletActive(false);
  };
  const walletHandler = () => {
    setWalletActive(true);
    setCardActive(false);
  };

  useEffect(() => {
    dispatch(fetchWallet());
  }, []);

  return (
    <div className={classes.main}>
      <Container className={classes.container}>
        <Hidden mdDown>
          <div className={classes.breadcrumbsHolder}>
            <ADGMBreadcrumbs paths={breadCrumbs} />
          </div>
        </Hidden>
        <Hidden mdUp>
          <div className={classes.mobileTitlehead}>
            <div>
              <Link href='/app/applications'>
                <ADGMImage name='croseblackonmobile.svg' alt='croseimg' />{' '}
                <FormattedMessage {...messages.payment_summary} />
              </Link>
            </div>
          </div>
        </Hidden>

        {!isEmpty(breakdown) && (
          <Grid container spacing={3} className={classes.gridContainer}>
            <Grid item xs={12} md={8}>
              {children}
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper variant='outlined' className={classes.paperCardFrame}>
                <div className={classes.titleHead}>
                  <Typography variant='h6' component='h2' className={classes.Title}>
                    <FormattedMessage {...messages.payment_with} />
                  </Typography>
                </div>
                <div className={classes.innerCardGrid}>
                  {lowBalance ? (
                    <div className={classes.adgmwalletDetail}>
                      <div className={classes.warningmassage}>
                        <ADGMImage name='Information.svg' alt='InformationIcon' />
                        <Typography variant='body1'>
                          <FormattedMessage {...messages.wallet_empty_message} />
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className={classes.debitcardDetail}>
                    <div className={classes.radioactiveHolder}>
                      <FormControl component='fieldset' className={classes.fieldsetradio}>
                        <RadioGroup className={classes.usercheckedradio}>
                          <Radio
                            value='card'
                            name='radio-button-demo'
                            inputProps={{ 'aria-label': 'A' }}
                            id='userRadioA'
                            checked={cardActive}
                            onClick={creditCardHandler}
                          />
                          <label htmlFor='userRadioA' className={classes.radioHelperText}>
                            <span>
                              <FormattedMessage {...messages.debit_credit_card} />
                            </span>
                          </label>
                        </RadioGroup>
                        {walletError?.statusCode !== '100033' && (
                          <RadioGroup className={classNames(classes.usercheckedradio, classes.usercheckedradioColumn)}>
                            <Radio
                              value='wallet'
                              name='radio-button-demo'
                              inputProps={{ 'aria-label': 'b' }}
                              id='userRadiob'
                              checked={walletActive}
                              onClick={walletHandler}
                              disabled={lowBalance}
                            />
                            <label htmlFor='userRadiob' className={classes.radioHelperTextColumn}>
                              <span>
                                <ADGMImage name='ADGMwallet.svg' alt='ADGMwallet' />{' '}
                                <FormattedMessage {...messages.dari_wallet} />
                              </span>
                              <span className={classes.textADGMGray}>
                                <FormattedMessage {...messages.balance} />:{' '}
                                <FormattedMessage
                                  {...messages.AED_amount}
                                  values={{ num: formatCurrencyWithoutCurrency(balance) }}
                                />
                              </span>
                            </label>
                          </RadioGroup>
                        )}
                      </FormControl>
                    </div>
                  </div>
                </div>
              </Paper>
              <Paper variant='outlined' className={classes.paperCardFrame}>
                <div className={classes.titleHead}>
                  <Typography variant='h6' component='h2' className={classes.Title}>
                    <FormattedMessage {...messages.payment_detail} />
                  </Typography>
                </div>
                <div className={classes.innerCardGrid}>
                  <Box display='flex' justifyContent='space-between' mb={1} className={classes.paymentHead}>
                    {keyEmptyCheck('OTHERS')}
                    <span className={classes.textright}>
                      <FormattedMessage {...messages.currency} /> {breakdown?.totalAmount}
                    </span>
                  </Box>

                  <Box display='flex' justifyContent='space-between' mb={1} className={classes.paymentDetails}>
                    {keyEmptyCheck('electronic_administrative_services_allowance')}
                    <span className={classes.textright}>
                      <FormattedMessage {...messages.currency} /> {breakdown?.dariAmount}
                    </span>
                  </Box>
                  <Box display='flex' justifyContent='space-between' mb={1} className={classes.paymentDetails}>
                    {keyEmptyCheck('vat')}
                    <span className={classes.textright}>
                      <FormattedMessage {...messages.currency} /> {breakdown?.vatCharges}
                    </span>
                  </Box>
                  <div className={classNames(classes.paymentDiscription, classes.totalpayment)}>
                    <FormattedMessage {...messages.total_payment} />
                    <span className={classes.textright}>
                      <FormattedMessage {...messages.currency} /> {breakdown?.totalAmount}
                    </span>
                  </div>

                  <Button variant='contained' className={classes.PaynowBtn} onClick={payNowHanlder}>
                    <FormattedMessage {...messages.pay_now} />
                  </Button>
                </div>
              </Paper>

              {showCancelApplication && (
                <Button
                  variant='text'
                  className={classNames(classes.rejectApplicationbtn, classes.cancelBtn)}
                  onClick={() => setModalOpenApplicationReject(true)}
                >
                  <ADGMImage name='trash_red.svg' alt='trash' aria-hidden />
                  <FormattedMessage {...messages.cancel_application} />
                </Button>
              )}
            </Grid>
          </Grid>
        )}

        {/* Cancel Modal */}
        <CancelApplicationModal
          open={isModalOpenApplicationReject}
          onClose={() => setModalOpenApplicationReject(false)}
          cancelApplication={submitCancelApplication}
        />
      </Container>
    </div>
  );
}

Payment.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  breadCrumbs: PropTypes.array.isRequired,
  balance: PropTypes.string.isRequired,
  paymentHanlder: PropTypes.func.isRequired,
  submitCancelApplication: PropTypes.func.isRequired,
  showCancelApplication: PropTypes.bool.isRequired,
  breakdown: PropTypes.object.isRequired,
};

export default withStyles(styles)(Payment);
